export default "__VITE_ASSET__Dw9z3gT3__"